import React from 'react';

const ToggleButtonGroupContext = React.createContext(undefined);
const useToggleButtonGroupContext = () => {
    const ctx = React.useContext(ToggleButtonGroupContext);
    return ctx;
};

export { ToggleButtonGroupContext, useToggleButtonGroupContext };
